import { render, staticRenderFns } from "./AddSubgroupWrapper.vue?vue&type=template&id=635e269f"
import script from "./AddSubgroupWrapper.vue?vue&type=script&lang=js"
export * from "./AddSubgroupWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports